import './style.css';

function AdviceDetail({item}){
    return <main className="home-container">
        <div className="advice-detail-wrapper">
            <h2 className="">{item.title}</h2>
            <div className="advice-detail-container">
                {item.listAdvices.map(a => {
                    return <div className="advice-detail-item-container">
                        <h3 className="advice-detail-item-title">{a.title}</h3>
                        <img className="advice-detail-item-image" alt="" src={a.image} />
                        <div className="advice-detail-content">
                            <p>{a.text}</p>
                        </div>
                    </div>
                })}
            </div>
            {item.imageDesc && <img className="advice-detail-item-image" src={item.imageDesc} alt=""/>}
        </div>
    </main>
}

export default AdviceDetail;